import { GoldCheck } from "@/components/GoldCheck";
import { BadgeCheck, Heart } from "lucide-react";

export const SupporterBadge = ({ size = "sm", testId, chip = false }) => (
  <span className="inline-flex items-center gap-1 shrink-0 align-middle">
  <GoldCheck className={size === "lg" ? "w-6 h-6" : "w-[18px] h-[18px]"} testId={testId ? `${testId}-check` : "supporter-check"} />
  <span data-testid={testId} title="Projekt Unterstützer – unterstützt das Projekt finanziell" className={`vip-chip ${size === "lg" || chip ? "inline-flex" : "hidden sm:inline-flex"} items-center gap-1 shrink-0 whitespace-nowrap align-middle rounded-full font-extrabold tracking-wider ${size === "lg" ? "text-xs px-2.5 py-1" : "text-[10px] px-1.5 py-px"}`}>
    <Heart className={size === "lg" ? "w-3.5 h-3.5 text-rose-500" : "w-2.5 h-2.5 text-rose-500"} fill="currentColor" strokeWidth={1.5} /> Projekt Unterstützer
  </span>
  </span>
);

export const RoleBadge = ({ creator, moderator, supporter, size = "sm", testId, chip }) => {
  const cls = size === "lg" ? "w-6 h-6" : "w-4 h-4";
  return (<>
    {(creator || moderator) && <BadgeCheck data-testid={testId} className={`${cls} fill-[#1d9bf0] text-white shrink-0`} strokeWidth={2.25} aria-label={creator ? "Itzcouple" : "Moderator"} />}
    {supporter && <SupporterBadge size={size} chip={chip} testId={testId ? `${testId}-supporter` : "supporter-badge"} />}
  </>);
};
